import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg ${
        isLarge ? 'aspect-[3/4]' : 'aspect-[2/3]'
      }`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-3">
          {comic.status === '连载中' && (
            <span className="inline-block text-[10px] px-2 py-0.5 rounded-full bg-accent-500 text-background-50 font-medium mb-1 whitespace-nowrap">
              {comic.status}
            </span>
          )}
          {comic.status === '已完结' && (
            <span className="inline-block text-[10px] px-2 py-0.5 rounded-full bg-secondary-500 text-background-50 font-medium mb-1 whitespace-nowrap">
              {comic.status}
            </span>
          )}
          <h3 className={`font-heading font-semibold text-background-50 line-clamp-1 ${
            isLarge ? 'text-base' : 'text-sm'
          }`}>
            {comic.title}
          </h3>
        </div>
      </div>
      <div className="mt-2 px-0.5">
        <div className="flex items-center justify-between">
          <p className="text-xs text-foreground-500 whitespace-nowrap">{comic.author}</p>
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-xs text-foreground-600">{comic.rating}</span>
          </div>
        </div>
        <div className="flex items-center gap-3 mt-1">
          <span className="text-[11px] text-foreground-400 whitespace-nowrap">
            <i className="ri-eye-line mr-0.5"></i>{(comic.views / 10000).toFixed(1)}万
          </span>
          <span className="text-[11px] text-foreground-400 whitespace-nowrap">
            <i className="ri-file-list-3-line mr-0.5"></i>{comic.chapters}话
          </span>
        </div>
      </div>
    </Link>
  );
}